import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const fetchHiringRequests = async () => {
  try {
    const response = await fetch(`${API_URL}Hiring/GetHiringRequest/${companyCode}`);
    if (!response.ok) throw new Error("Failed to fetch hiring requests");
    return await response.json();
  } catch (error) {
    console.error("Error fetching hiring requests:", error);
    return [];
  }
};

export const saveHiringRequest = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/AddHiringRequest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    }
    const errorData = await response.json().catch(() => ({}));
    return { success: false, status: response.status, message: errorData?.message || 'Something went wrong.', error: errorData };
  } catch (error) {
    console.error('API call failed:', error);
    return { success: false, message: error.message || 'Network or server error', error };
  }
};

export const SaveHiringRequestStatus = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/InsertHiringRequestStatus`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to save hiring request status');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

// Business Owner recalls a submitted request: new_status = "Draft" or "Withdrawn".
export const CallBackHiringRequest = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/CallBackHiringRequest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to call back hiring request');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateFinanceManagerApproved = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UpdateFinanceManagerApproved`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update finance manager approval');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateHRDirectorApproved = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UpdateHRDirectorApproved`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update HR Director approval');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateCEOApproved = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UpdateCEOApproved`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update CEO approval');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateIsConevrtToSource = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UpdateIsConevrtToSource`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update convert to source');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateHiringRequest = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UpdateHiringRequest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    throw new Error('Failed to update hiring request');
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const deleteDocument = async (reference_id) => {
  try {
    const response = await fetch(`${API_URL}Hiring/DeleteDocument/${reference_id}`, {
      method: 'DELETE',
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UploadFileMetadata = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Hiring/UploadFileMetadata`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const HiringRequestStatusHistory = async (requestId) => {
  try {
    const response = await fetch(`${API_URL}Hiring/GetHiringRequestStatusHistory/${requestId}`);
    if (!response.ok) throw new Error("Failed to fetch hiring request status history");
    return await response.json();
  } catch (error) {
    console.error("Error fetching hiring request status history:", error);
    return [];
  }
};
